import _cloneDeep from 'lodash/cloneDeep';
import initialState from './initialState';
import actionTypes from './actionTypes';

const sourceExplorerReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.GET_TABLE_RECORDS_SUCCESS: {
            const {
                tableName, columns, records, columnDefinitions, sourceFieldSettings, contextMenuItems,
            } = action.payload;
            return {
                ...state,
                columnDefinitions,
                columns,
                tableName,
                records, contextMenuItems,
                sourceFieldSettings: {
                    ...state.sourceFieldSettings,
                    ...sourceFieldSettings,
                },
            };
        }
        case actionTypes.CLEAN_API_LOGGERS: {
            return {
                ...state,
                apiLoggers: [],
            };
        }
        case actionTypes.ADD_API_LOGGERS: {
            const newLoggers = _cloneDeep(state.apiLoggers);
            newLoggers.push(action.payload);
            return {
                ...state,
                apiLoggers: newLoggers,
            };
        }
        case actionTypes.DATA_DASHBOARD: {
            return {
                ...state,
                dashboardData: action.payload,
            };
        }
        case actionTypes.GET_PENDING_FILE_UPLOADS: {
            return {
                ...state,
                filesPendingApproval: action.payload,
            };
        }
        case actionTypes.GET_RECORDS_FOR_AUTHORIZATION: {
            return {
                ...state,
                recordsForAuth: action.payload
            }
        }
        default:
            return state;
    }
};

export default sourceExplorerReducer;
